import { Status } from './models';

export class UnitType extends Status {
  // This is the name used as module name of the Vuex Store.
  static entity = 'unit_types';

  static fields() {
    return {
      ...super.fields(),
    };
  }
}

export default UnitType;
